
// 系统环境参数
let systemKey = "student-pc"
let domain = process.env.NODE_ENV=="development" ? "https://t.dailyedu.com":location.protocol + "//" + location.host
// let domain = "https://www.dailyedu.com"
let domainApi = `${domain}/api`
// let domainManageApi = `${domain}/manage-api`
let domainManageApi = `${domain}/api`
let wxDomain = "https://wx.dailyedu.com.cn"
const WITSBOX_ENV_PARAM = {
	RTCourseId: ['5c9834636513fc88ef96b2a9', '5cc7b640df246f6ce912cb8d', '5e4f51d32c54f15d5c60b638','665575dc4f0381c6e036c35b', '6694b44d4f0381c6e06c5a06', '61cbd8ea2c54f14c5ed85f41','6694ad6bc67da87e9aa68840','5cb96533df246f6730d7d9c7'],
	LACourseIds: ['5c9834636513fc88ef96b297','669dcb7f4f0381c6e0c96f63','63a15b5b2c54f157249f26af'],
	LAjobCourseIds: ['5c9834636513fc88ef96b29c', '63a25e702c54f157249f2768'],
	WFSCourseIds: ['620b4b422c54f1664eff84f2','5c9834636513fc88ef96b28f','5e0ef6292c54f111ed49e983','5e8e83be2c54f15c489c91a8','621601e82c54f163ff0c7943','628f137b2c54f13b1fc85022'],
	languageCourseId:['66ebe44fc67da873d65f2693', '6719acb9b3df383aa10fcb5e','6721d834b3df3808eab17f4e','67233c7ec67da8018fad9432','67233e2ac67da8018fad94bf','67233d87c67da8018fad9482','67233d18c67da8018fad9464','66f4f819c67da868f6452642','6719bda9b3df383aa10fcbca','67233cd7c67da8018fad944d','67233db3c67da8018fad948f','67233d40c67da8018fad946d','6723433ec67da8018fad96e7','67a5a8671821fb7a5942221f','67bec1c61821fb4efa6ec4df', '67a70c601821fb609b6fea27', '67bec25b1821fb4efa6ec4f1','67c68acbc67da878b51e2166','67c68b76c67da878b51e2182','67c68b15c67da878b51e2170','67c68bafc67da878b51e2191', '68d8aa7dc67da85dd269215b', '68d8aa42c67da85dd269214d', '67a577d1c67da847b8813ae7','682d467cc67da8340948c1f2', '67a5759cc67da847b8813aa8', '682d4805c67da8340948c237', '69d5ebd6c67da8682b690bc5', '69d5eecdc67da8682b691779', '69d5ef30c67da8682b691793', '69d5ef95c67da8682b6917a1', '69d5f748c67da8682b692f8e'],
	liveLangCourseIds: ['66ebe44fc67da873d65f2693', '6719acb9b3df383aa10fcb5e','6721d834b3df3808eab17f4e','67233c7ec67da8018fad9432','67233e2ac67da8018fad94bf','67233d87c67da8018fad9482','67233d18c67da8018fad9464','67a5a8671821fb7a5942221f','67bec1c61821fb4efa6ec4df','67c68acbc67da878b51e2166','67c68b76c67da878b51e2182', '68d8aa42c67da85dd269214d','682d467cc67da8340948c1f2', '67a5759cc67da847b8813aa8', '69d5ebd6c67da8682b690bc5', '69d5eecdc67da8682b691779', '69d5ef30c67da8682b691793', '69d5ef95c67da8682b6917a1', '69d5f748c67da8682b692f8e'], 
	videoLangCourseIds: ['66f4f819c67da868f6452642','6719bda9b3df383aa10fcbca','67233cd7c67da8018fad944d','67233db3c67da8018fad948f','67233d40c67da8018fad946d','6723433ec67da8018fad96e7', '67a70c601821fb609b6fea27', '67bec25b1821fb4efa6ec4f1','67c68b15c67da878b51e2170','67c68bafc67da878b51e2191', '68d8aa7dc67da85dd269215b', '67a577d1c67da847b8813ae7', '682d4805c67da8340948c237'],
		timeStart:1722268800000, // 1722355200000
		freeLearningCardArr:[
					{
						days: 30,
						name: '月卡',
						price: 69,
						amount: 69,
						type: 'month'
					},
					{
						days: 90,
						name: '季卡',
						price: 199,
						amount: 199,
						type: 'season'
					},
					{
						days: 180,
						name: '半年卡',
						price: 369,
						amount: 369,
						type: 'half-year'
					}
				],
	crmApi:domain+'/daiencrm/prod-api',
  domain: domain,
  IMAccountPrefix: domain == 'https://t.witsbox.com'||domain == 'https://t2.witsbox.com'||domain == 'https://t.dailyedu.com' ? 'test' : 'prod', 
  systemKey: systemKey,
  baseUrl: domainApi,
	baseUrlManage: domainManageApi,
  saleUrl: `https://wx.dailyedu.com.cn/sale/#`,
  examUrl: `${domain}/exam`,
  neoUrl: `${domain}/neo`,
  hostUrl: process.env.NODE_ENV=="development" ? "http://localhost:8082/#":`${domain}/${systemKey}/#`,
  classroom: `${domain}/classroom/html`,
  studentMbUrl: `${wxDomain}/student-mb`,  //通过扫码打开移动端
  loginPage: `${domain}/${systemKey}/`,
  competitionUrl: `${domain}/competition/#`,
  ossObject: {},
  client: {},
	levelOptions: {
	    0: 0,
	    1: 100,
	    2: 400,
	    3: 1400,
	    4: 4400,
	    5: 9400,
	    6: 21000,
	    7: 45000,
	    8: 81000,
	    9: 129000,
	    10: 189000,
	    11: 261000,
	    12: 345000,
	    13: 441000,
	    14: 549000,
	    15: 629000,
		16: 800000,
	    17: 1000000,
	},
}
export default WITSBOX_ENV_PARAM



// WEBPACK FOOTER //
// ./utils/common.js